export type UserFilters = {
  q?: string
}

export type ChangePasswordFields = {
  currentPassword: string
  password: string
  passwordConfirmation: string
}

export enum UserRoles {
  'OWNER' = 1,
  'MANAGER' = 2,
  'STAFF' = 3,
}

type Country = {
  id: number
  label: string
  code: string
}

export interface UserParams {
  id: string
  firstName?: string
  lastName?: string
  email: string
  role: number
  confirmed: boolean
  blocked: boolean
  country: Country
  guide: boolean
}

export class User {
  public id: string
  public email: string
  public firstName?: string
  public lastName?: string

  public role: number
  public blocked: boolean
  public confirmed: boolean
  public country: Country
  public guide: boolean

  constructor(params: UserParams) {
    this.id = params.id
    this.firstName = params.firstName
    this.lastName = params.lastName
    this.email = params.email
    this.role = params.role
    this.confirmed = params.confirmed
    this.blocked = params.blocked
    this.country = params.country
    this.guide = params.guide
  }

  isRole(role: UserRoles) {
    return this.role === role
  }

  canEditUser(user: User) {
    // If this is owner or manager, it can edit managers and staff
    // Users cannot edit themselves

    if (this.id === user.id) return false
    if (this.isRole(UserRoles.OWNER) && !user.isRole(UserRoles.OWNER)) return true
    if (this.isRole(UserRoles.MANAGER) && user.isRole(UserRoles.MANAGER)) return true
    if (!this.isRole(UserRoles.STAFF) && user.isRole(UserRoles.STAFF)) return true

    return false
  }

  canCreateUserRole(role: UserRoles) {
    // Owners can create every role, managers can only create managers and staff

    if (this.isRole(UserRoles.OWNER)) return true
    if (this.isRole(UserRoles.MANAGER) && role !== UserRoles.OWNER) return true

    return false
  }
}
